import { render, staticRenderFns } from "./AudioTable.vue?vue&type=template&id=61391989&scoped=true&"
import script from "./audiotable.js?vue&type=script&lang=js&"
export * from "./audiotable.js?vue&type=script&lang=js&"
import style0 from "./AudioTable.vue?vue&type=style&index=0&id=61391989&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61391989",
  null
  
)

export default component.exports